import { createFileRoute } from "@tanstack/react-router"
import { SocialLinkCallbackPage } from "@/pages/SocialLinkCallbackPage"

export const Route = createFileRoute(
  "/_authenticated/_account/account-settings/security/social-link-callback"
)({
  component: SocialLinkCallbackPage,
})
